import styled from '@emotion/styled';
import { Delete24Icon } from '@kep-ui-kit/ui-icons';

import { StyledButton } from '@selfserve/react-ui';

const StyledRemoveValueButton = styled(StyledButton, {
  shouldForwardProp: (prop) => prop !== 'leftSide',
})(
  ({
    theme,
    disabled,
    leftSide,
  }: {
    theme?: any;
    disabled?: boolean;
    leftSide?: boolean;
  }) => ({
    border: 'none',
    padding: 0,
    width: 'fit-content',
    height: '100%',
    minWidth: 'auto',
    margin: 0,
    position: 'absolute',
    ...(leftSide
      ? {
        left: '-52px',
        borderRight: `1px solid ${theme.palette.grey[600]}`,
        paddingRight: '8px',
      }
      : {
        right: '-56px',
        borderLeft: `1px solid ${theme.palette.grey[600]}`,
        paddingLeft: '8px',
      }),
    top: 0,
    borderRadius: 0,
    svg: {
      color: disabled ? theme.palette.grey['400'] : theme.palette.danger.main,
    },
  })
);

interface Props {
  onClick: () => void;
  leftSide?: boolean;
  disabled: boolean;
}

export const RemoveValueButton = (props: Props) => (
  <StyledRemoveValueButton {...props} variant="borderless" isBorderless>
    <Delete24Icon />
  </StyledRemoveValueButton>
);
